/* import __COLOCATED_TEMPLATE__ from './main-container.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();